
import {
  computed, defineComponent, reactive, watch,
} from 'vue';
import SelecionarPessoa from '@/components/Cadastros/Pessoas/SelecionarPessoa.vue';
import { useModalBase } from '@/core/composables/ModalBase';
import { ETipoRelacaoPessoa } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoRelacaoPessoa';
import { useTelaBase } from '@/core/composables/TelaBase';
import Icone from '@/core/components/Icone.vue';

export default defineComponent({
  name: 'SelecionarClienteModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      default: 0,
    },
    codigoPessoa: {
      type: Number,
      default: 0,
    },
    codigoCliente: {
      type: Number,
      default: 0,
    },
  },
  components: {
    SelecionarPessoa,
    Icone,
  },
  emits: ['confirmar', 'update:codigoPessoa', 'update:codigoCliente'],
  setup(props, { emit }) {
    const { modalBase } = useModalBase(props, emit);
    const { telaBase } = useTelaBase();
    const state = reactive({
      codigoCliente: 0,
      codigoPessoa: 0,
    });

    const computedCodigoCliente = computed({
      get: () => props.codigoCliente,
      set: (val: number) => {
        emit('update:codigoCliente', val);
      },
    });

    const computedCodigoPessoa = computed({
      get: () => props.codigoPessoa,
      set: (val: number) => {
        emit('update:codigoPessoa', val);
      },
    });

    function alterarPessoa() {
      computedCodigoCliente.value = state.codigoCliente;
      computedCodigoPessoa.value = state.codigoPessoa;
    }

    function confirmar() {
      computedCodigoCliente.value = state.codigoCliente;
      computedCodigoPessoa.value = state.codigoPessoa;
      emit('confirmar');
      modalBase.computedVisivel = false;
    }

    watch(async () => modalBase.computedVisivel, async () => {
      if (modalBase.computedVisivel) {
        telaBase.carregando = true;
        telaBase.carregando = false;
      }
    });

    return {
      props,
      state,
      modalBase,
      ETipoRelacaoPessoa,
      computedCodigoCliente,
      computedCodigoPessoa,
      confirmar,
      alterarPessoa,
    };
  },
});
